import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectOption, SelectSize } from 'Shared/Form/Select';
import { FormikSelect } from 'Shared/Form/Formik';
import { GridItem } from 'Shared/Grid';
import * as S from '../Profile.styles';

export interface SelectWrapperProps {
  options: SelectOption[];
  name?: string;
  translationKey: 'location' | 'department' | 'country' | 'state' | 'province';
  onChange?(value: string): void;
}

const SelectWrapper = ({
  options,
  name,
  translationKey,
  onChange,
}: SelectWrapperProps) => {
  const { t: translate } = useTranslation('account');

  return (
    <GridItem sm={4} md={4} lg={6}>
      <S.FormField>
        <FormikSelect
          name={name ?? translationKey}
          placeholder={translate(
            `profile.${translationKey}_select_placeholder`,
          )}
          onChange={onChange}
          options={options}
          size={SelectSize.Regular}
          LabelComponent={a11yProps => (
            <S.FieldLabel {...a11yProps}>
              {translate(`profile.${translationKey}_select_label`)}
            </S.FieldLabel>
          )}
        />
      </S.FormField>
    </GridItem>
  );
};

export default SelectWrapper;
